import React from "react";
import QuoteFormContent from "../QuoteFormContent";

export default function QuoteFormPage() {
  return <QuoteFormContent />;
}
